'use client';

import { useEffect } from 'react';

/** Keeps the server's canonical origin during client listing navigation. */
export const useListingCanonical = (canonicalHref: string | undefined): void => {
  useEffect(() => {
    if (canonicalHref === undefined) return;
    const link = document.head.querySelector('link[rel="canonical"]');
    const existing = link?.getAttribute('href');
    if (existing === null || existing === undefined) return;
    const absolute = new URL(canonicalHref, new URL(existing, document.baseURI)).href;
    link?.setAttribute('href', absolute);
    document.head.querySelector('meta[property="og:url"]')?.setAttribute('content', absolute);
  }, [canonicalHref]);
};
